import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ISupportUserRepository } from 'application/repositorySchemas/ISupportUserRepository';

// UseCase
export interface ISupportUserLogout {
    readonly supportUserToken: ISupportUserTokenRepository;
    readonly supportUser: ISupportUserRepository;
    execute(): Promise<void>;
}

// Interactor
@injectable()
export class SupportUserLogout implements ISupportUserLogout {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ISupportUserRepository')
        public readonly supportUser: ISupportUserRepository,
    ) {}

    public async execute() {
        const token = this.supportUserToken.get();
        if (token === null) {
            return;
        }
        await this.supportUser.logout();
        this.supportUserToken.remove();
    }
}
